// extracted by mini-css-extract-plugin
export default {"base":"Card_base__7yfXv"};